import ContractActivity from './index';
import RecruitAudit from './recruitAudit';
import InviteConf from './inviteConf';
import MatchConf from './matchConf';

export default {
    path: '/home/contract/activity',
    component: ContractActivity,
    children: [
        { path: '/home/contract/activity/audit', component: RecruitAudit },
        { path: '/home/contract/activity/invite-conf', component: InviteConf},
        { path: '/home/contract/activity/match-conf', component: MatchConf}
    ]
}